// The site has no unit setting, so distances read in miles for viewers in the
// countries that still use them on road signs, and in kilometers elsewhere.
const MILES_COUNTRIES = new Set(['United States', 'United Kingdom', 'Liberia', 'Myanmar']);

export function prefersMiles(location) {
	const countryName = location?.country?.name;
	return MILES_COUNTRIES.has(countryName);
}
